import type { SVGProps } from "react";
export interface TrashClockIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TrashClockIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TrashClockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.397 4.38a1.126 1.126 0 0 1 1.207.905l.017.112 1.103 12.135c.071.788.12 1.316.189 1.72.066.39.14.578.213.703l.159.229c.175.215.396.39.649.51l.112.045c.129.043.312.08.608.104.41.032.938.032 1.729.032H9.5a1.125 1.125 0 0 1 0 2.25h-.117c-.756 0-1.387.001-1.904-.04-.465-.036-.906-.11-1.33-.28l-.18-.08a4.1 4.1 0 0 1-1.612-1.365l-.167-.258c-.27-.457-.406-.947-.495-1.472q-.065-.383-.113-.856l-.1-1.038L2.38 5.603l-.004-.116a1.125 1.125 0 0 1 1.022-1.108Zm15.205 0a1.126 1.126 0 0 1 1.019 1.223l-.236 2.584-.016.114a1.124 1.124 0 0 1-2.224-.318l.234-2.586a1.126 1.126 0 0 1 1.223-1.018Z"
      />
      <path
        fill={color}
        d="M20.875 17a3.874 3.874 0 1 0-7.749 0 3.874 3.874 0 0 0 7.749 0m-5-2a1.125 1.125 0 0 1 2.25 0v1.121l1.148.287a1.126 1.126 0 0 1-.546 2.183l-2-.5A1.125 1.125 0 0 1 15.875 17zM12.585.876c.432.004.84.028 1.225.154l.306.118c.3.135.577.315.822.537l.143.142c.322.343.557.773.817 1.229l.755 1.32H20l.116.005a1.126 1.126 0 0 1 0 2.239L20 6.625H2a1.125 1.125 0 0 1 0-2.25h3.347l.974-1.704c.219-.374.442-.716.742-.987l.254-.207c.266-.194.56-.346.873-.448l.195-.054c.327-.079.67-.097 1.03-.1zm-2.728 2.25c-.565 0-.776.007-.884.023l-.084.02a1 1 0 0 0-.167.076l-.15.108a.9.9 0 0 0-.144.189l-.372.63-.118.204h6.124l-.118-.204c-.28-.49-.39-.67-.458-.756l-.059-.063a1 1 0 0 0-.15-.108l-.166-.077c-.092-.03-.216-.042-.968-.042zM23.125 17a6.124 6.124 0 1 1-12.249 0 6.124 6.124 0 0 1 12.249 0"
      />
    </svg>
  );
}
